import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [100, 0],
      width: "inherit",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    loader: {
      color: theme.palette.lightAqua,
    },
  }),
  { name: "LoaderSpinner" },
);
